import React, { useEffect, useState } from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import rehypeRaw from 'rehype-raw';
import LangflowApiService from '../services/LangflowApiService';
import './KtmbDelays.css';

const KtmbDelays = ({ hours = 24, limit = 10 }) => {
  const [ktmbDelays, setKtmbDelays] = useState([]);
  const [ktmbDelaysLoading, setKtmbDelaysLoading] = useState(false);
  const [ktmbDelaysError, setKtmbDelaysError] = useState(null);
  const [carouselIndex, setCarouselIndex] = useState(0);

  useEffect(() => {
    setKtmbDelaysLoading(true);
    LangflowApiService.getKtmbDelay(hours, limit)
      .then(data => {
        if (data && data.status === 'success' && Array.isArray(data.delays)) {
          setKtmbDelays(data.delays);
        } else {
          setKtmbDelays([]);
          setKtmbDelaysError('No delay data found.');
        }
      })
      .catch(() => setKtmbDelaysError('Failed to fetch KTMB delays.'))
      .finally(() => setKtmbDelaysLoading(false));
  }, [hours, limit]);

  // Card click handler: go to next card
  const goNext = () => setCarouselIndex(i => (i === ktmbDelays.length - 1 ? 0 : i + 1));

  // Helper for next card index
  const getNextIndex = () => (carouselIndex + 1) % ktmbDelays.length;

  return (
    <>
      {ktmbDelaysLoading && <div>Loading delays...</div>}
      {/* {ktmbDelaysError && <div style={{ color: 'red' }}>{ktmbDelaysError}</div>} */}
      {ktmbDelays && ktmbDelays.length > 0 && (
        <div className="ktmb-delays-section">
          {ktmbDelays.length === 1 ? (
            <ul className="ktmb-delays-list">
              <li className="ktmb-delay-item decorated">
              <div className="ktmb-service-card-icon">
              <span>🔔</span>
            </div>
                <span className="ktmb-delay-train">{ktmbDelays[0].train}</span> <span className="ktmb-delay-route">{ktmbDelays[0].route}</span><br />
                <span className="ktmb-delay-time">{ktmbDelays[0].delay_time} delay</span> —
                <span className="ktmb-delay-message">
                  <ReactMarkdown
                    remarkPlugins={[remarkGfm]}
                    rehypePlugins={[rehypeRaw]}
                    components={{
                      a: ({ node, href, children, ...props }) => (
                        <a 
                          href={href} 
                          target="_blank" 
                          rel="noopener noreferrer"
                          style={{ color: '#007bff', textDecoration: 'underline' }}
                          {...props}
                        >
                          {children}
                        </a>
                      )
                    }}
                  >
                    {typeof ktmbDelays[0].message === 'string' ? ktmbDelays[0].message : ''}
                  </ReactMarkdown>
                </span>
                <div className="ktmb-delay-meta">
                  Reported: {new Date(ktmbDelays[0].reported_time).toLocaleString()}
                </div>
              </li>
            </ul>
          ) : (
            <>
              <div className="ktmb-delays-carousel" style={{ position: 'relative', minHeight: 0 }}>
                {/* Main card */}
                <ul className="ktmb-delays-list" style={{width: '100%', margin: 0, position: 'relative', zIndex: 2}}>
                  <li className="ktmb-delay-item decorated" onClick={goNext} style={{ cursor: 'pointer' }}>
                  <div className="ktmb-service-card-icon">
                    <span>🔔</span>
                    </div>
                    <span className="ktmb-delay-train">{ktmbDelays[carouselIndex].train}</span> <span className="ktmb-delay-route">{ktmbDelays[carouselIndex].route}</span><br />
                    <span className="ktmb-delay-time">{ktmbDelays[carouselIndex].delay_time} delay</span> —
                    <span className="ktmb-delay-message">
                      <ReactMarkdown
                        remarkPlugins={[remarkGfm]}
                        rehypePlugins={[rehypeRaw]}
                        components={{
                          a: ({ node, href, children, ...props }) => (
                            <a 
                              href={href} 
                              target="_blank" 
                              rel="noopener noreferrer"
                              style={{ color: '#007bff', textDecoration: 'underline' }}
                              {...props}
                            >
                              {children}
                            </a>
                          )
                        }}
                      >
                        {typeof ktmbDelays[carouselIndex].message === 'string' ? ktmbDelays[carouselIndex].message : ''}
                      </ReactMarkdown>
                    </span>
                    <div className="ktmb-delay-meta">
                      {/* From: {ktmbDelays[carouselIndex].from_station} &rarr; {ktmbDelays[carouselIndex].to_station}<br /> */}
                      Reported: {new Date(ktmbDelays[carouselIndex].reported_time).toLocaleString()}
                    </div>
                  </li>
                </ul>
                <div className="ktmb-delays-carousel-indicator">{carouselIndex + 1} / {ktmbDelays.length}</div>
              </div>
              {/* Pagination dots */}
              <div className="ktmb-delays-pagination">
                {ktmbDelays.map((_, idx) => (
                  <span
                    key={idx}
                    className={`ktmb-delays-dot${carouselIndex === idx ? ' active' : ''}`}
                  />
                ))}
              </div>
            </>
          )}
        </div>
      )}
    </>
  );
};

export default KtmbDelays; 